<template>
  <el-card shadow="always" :body-style="{ display: 'none'}">
    <div slot="header" class="clearfix">
      <el-col :lg="8">
        {{ title }}
        <small>({{ total }} registros)</small>
      </el-col>
      <el-col :offset="8" :lg="8">
        <ShippingHeaderPagination v-if="total > 0" :total="total" @fetch="fetch" />
      </el-col>
    </div>
  </el-card>
</template>

<script>
import ShippingHeaderPagination from './ShippingHeaderPagination.vue';

export default {
    name: "ShippingHeaderList",
    props: ["title", "total", "pagination"],
    methods: {
      fetch(records, page) {
        this.$emit("fetch", records, page);
      },
      search(filter) {
        this.$emit("search", filter);
      },
    },
    components: {
      ShippingHeaderPagination,
    }
}
</script>